import { render, staticRenderFns } from "./editCompany.vue?vue&type=template&id=16de0bfa&scoped=true"
import script from "./editCompany.vue?vue&type=script&lang=js"
export * from "./editCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16de0bfa",
  null
  
)

export default component.exports